<template>
	<div class="news-info">
		<div class="news-content">
			<div class="info-title" v-if="$locale == 'zh'">{{datainfo.title}}</div>
			<div class="info-title" v-if="$locale == 'en'">{{datainfo.titleEnglish}}</div>
			<div class="info-title" v-if="$locale == 'de'">{{datainfo.titleGerman}}</div>
			<div class="info-time">
				{{datainfo.createTime}}
			</div>
			<div class="info-text" v-html="content"></div>
			<div class="info-down u-flex u-col-center u-row-between">
				<span @click="up">{{$t('上一条')}}</span>
				<span @click="tomore">{{$t('查看更多')}}</span>
				<span @click="down">{{$t('下一条')}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				datainfo: {},
				content: '',
				newlist:[],
				newindex:0,
				id: '',
				typeid: '',
			}
		},
		created() {
			this.$parent.settitle(this.$t('新闻详情'))
			// this.id = this.$route.
			this.newindex = window.localStorage.newindex ? Number(window.localStorage.newindex) : 0
			this.newlist = window.localStorage.newlist ? JSON.parse(window.localStorage.newlist) : []
			this.getdata()
		},
		watch:{
			$route(){
				this.getdata()
			}
		},
		methods: {
			tomore(){
				this.$router.go(-1)
			},
			up() {
				/* if (this.newindex == 0) {
					this.$message.error(this.$t('已经是第一篇了'))
				} else {
					this.newindex = this.newindex - 1
					var id = this.newlist[this.newindex].id
					window.localStorage.newindex = this.newindex
					this.$router.replace({
						path:'/news-info',
						query:{
							id:id
						}
					})
				} */
				this.$http.post('/api/Index/getLast',{
					id: this.$route.query.id
				}).then((res) => {
					if(res.result) {
						var id = res.result.id
						this.$router.replace({
							path:'/news-info',
							query:{
								id:id
							}
						})
					} else {
						this.$message.error(this.$t('已经是第一篇了'))
					}
				})
			},
			down() {
				/* if (this.newindex == (this.newlist.length - 1)) {
					this.$message.error(this.$t('没有下一篇了'))
				} else {
					this.newindex = this.newindex + 1
					var id = this.newlist[this.newindex].id
					window.localStorage.newindex = this.newindex
					this.$router.replace({
						path:'/news-info',
						query:{
							id:id
						}
					})
				} */
				this.$http.post('/api/Index/getNast',{
					id: this.$route.query.id
				}).then((res) => {
					if(res.result) {
						var id = res.result.id
						this.$router.replace({
							path:'/news-info',
							query:{
								id:id
							}
						})
					} else {
						this.$message.error(this.$t('没有下一篇了'))
					}
				})
			},
			getdata() {
				this.$http.post('/api/Index/getNewsD', {
					id: this.$route.query.id
				}).then(res => {
					this.datainfo = res.result
					const regex = new RegExp('<img', 'gi')
					if (this.$locale == 'zh') {
						this.content = res.result.content.replace(regex, `<img style="max-width: 100%; height: auto"`)
					} else if (this.$locale == 'en') {
						this.content = res.result.contentEnglish.replace(regex, `<img style="max-width: 100%; height: auto"`)
					} else {
						this.content = res.result.contentGerman.replace(regex, `<img style="max-width: 100%; height: auto"`)
					}
				})
			}
		}
	}
</script>

<style lang="scss">

</style>
